import { tv } from 'tailwind-variants'

export const cardComunicado = tv({
  base: 'px-0 py-0 mb-deca text-black hover:bg-secondary-light hover:cursor-pointer',
  variants: {
    read: {
      true: 'opacity-70 border',
      false: 'border border-primary-xlight'
    }
  }
})

export const tag = tv({
  base: 'font-bold px-mili opacity-1',
  variants: {
    read: {
      true: 'bg-success-xlight text-success-medium',
      false: 'bg-primary-xlight text-primary-medium'
    }
  }
})
